export default __webpack_public_path__ + "static/media/Almacenamos-09.055d8020.svg";